import React, { useState, useEffect } from 'react';
import '../styles/QuestionResponseFormStyles.scss';
import feedbackArrow from '../assets/feedback-arrow.svg';
import feedbackAtom1 from '../assets/feedback-atom-1.svg';
import feedbackAtom2 from '../assets/feedback-atom-2.png';
import feedbackAtom3 from '../assets/feedback-atom-3.svg';
import PhoneNumberInputComponent from './PhoneNumberInputComponent';
import TextInputRequiredComponent from './TextInputRequiredComponent';
import ButtonComponent from './ButtonComponent';
import ErrorOverlay from './ErrorOverlay';

const QuestionResponseFormSection = ({ onSuccess, onError }) => {
  const [formData, setFormData] = useState({ name: '', phone: '' });
  const [error, setError] = useState('');
  const [formKey, setFormKey] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOrderConsultation = async () => {
    if (isSubmitting) return;

    if (!formData.name || !formData.phone) {
      setError('Необходимо заполнить все поля');
      return;
    }

    const digitsOnly = formData.phone.replace(/\D/g, '');
    if (digitsOnly.length < 8 || digitsOnly.length > 15) {
      setError('Номер должен содержать от 8 до 15 цифр');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch('https://lims.backend.demowts.ru/api/feedback', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      await response.json();

      if (response.ok) {
        if (typeof window !== 'undefined' && typeof window.ym === 'function') {
          window.ym(96616171, 'reachGoal', 'success-order');          
        }
        onSuccess(true);
        setFormData({ name: '', phone: '' });
        setFormKey(prev => prev + 1);
      } else {
        setError('Произошла ошибка при отправке данных');
        onError(true, 'Произошла ошибка при отправке данных');
      }
    } catch (error) {
      setError('Произошла ошибка при отправке данных');
      onError(true, 'Произошла ошибка при отправке данных');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    setTimeout(() => {
      setError('')
    }, 2000);
  }, [error])

  return (
    <>
      {error && <ErrorOverlay message={error} />}

      <div className="question-response-container">
        <img src={feedbackAtom1} alt="feedback-atom" className="feedback-atom-1" />
        <img src={feedbackAtom2} alt="feedback-atom" className="feedback-atom-2" />
        <img src={feedbackAtom3} alt="feedback-atom" className="feedback-atom-3" />
        <img src={feedbackArrow} alt="feedback-arrow" className="feedback-arrow" />

        <div className="question-response-form-container" key={formKey}>
          <h2 className="question-response-title">Не нашли ответ на свой вопрос?</h2>
          <p className="question-response-text">
            Оставьте свой номер и мы обязательно свяжемся с вами!
          </p>

          <TextInputRequiredComponent
            placeholder="Ваше имя"
            label="Имя"
            value={formData.name}
            onChange={(value) => handleInputChange('name', value)}
          />
          <PhoneNumberInputComponent
            placeholder="+7 (---) --- -- --"
            value={formData.phone}
            onChange={(value) => handleInputChange('phone', value)}
          />
          <ButtonComponent
            className="question-response-button button-style-1"
            type="button"
            onClick={handleOrderConsultation}
            disabled={isSubmitting}
          >
            Заказать консультацию
          </ButtonComponent>
        </div>
      </div>
    </>
  );
};

export default QuestionResponseFormSection;
